import { itCH } from "../../../../date-fns/locale/it-CH.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    itCH
  }
};